"use client";

import { useState } from "react";
import { Portal } from "../_common/Portal";

export type Sinsal = { name: string; type: string; positions: string[]; desc: string; base: string; manifest?: string };

// 신살·길성 칩 — 클릭 시 설명을 모달 툴팁으로 표시. (사주 페이지 + 공유 페이지 공용)
export function SinsalChips({ sinsal }: { sinsal: Sinsal[] }) {
  const [open, setOpen] = useState<number | null>(null);
  if (!sinsal?.length) return <div style={{ fontSize: 12.5, color: "var(--ink-faint)" }}>특기할 신살 없음</div>;
  const sel = open !== null ? sinsal[open] : null;

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 7 }}>
      {sinsal.map((s, i) => (
        <button key={i} onClick={() => setOpen(i)}
          style={{ font: "inherit", cursor: "pointer", fontSize: 11.5, padding: "6px 11px", borderRadius: 99,
            background: s.type === "길성" ? "var(--accent-soft)" : "var(--chip)",
            border: `1px solid ${s.type === "길성" ? "var(--line-strong)" : "var(--chip-line)"}`,
            color: s.type === "길성" ? "var(--gold-bright)" : "var(--ink-dim)" }}>
          {s.type === "길성" ? "✦ " : ""}{s.name} <span style={{ opacity: 0.5 }}>ⓘ</span>
        </button>
      ))}

      {sel && (
        <Portal>
        <div onClick={() => setOpen(null)}
          style={{ position: "fixed", inset: 0, zIndex: 80, background: "rgba(0,0,0,0.55)", backdropFilter: "blur(3px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 18 }}>
          <div onClick={(e) => e.stopPropagation()}
            style={{ width: "100%", maxWidth: 380, background: "linear-gradient(var(--card-2), var(--card-2)), var(--bg)", border: "1px solid var(--line-strong)", borderRadius: 18, padding: "22px 20px", boxShadow: "0 20px 60px rgba(0,0,0,0.5)" }}>
            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 8, gap: 12 }}>
              <div style={{ fontFamily: "'Noto Serif KR',serif", fontSize: 18, fontWeight: 600, color: sel.type === "길성" ? "var(--gold-bright)" : "var(--ink)" }}>
                {sel.type === "길성" ? "✦ " : ""}{sel.name}
              </div>
              <button onClick={() => setOpen(null)} aria-label="닫기"
                style={{ flex: "none", font: "inherit", cursor: "pointer", border: "none", background: "transparent", color: "var(--ink-faint)", fontSize: 22, lineHeight: 1 }}>×</button>
            </div>
            <div style={{ fontSize: 11.5, color: "var(--ink-faint)", marginBottom: 12 }}>
              {sel.positions.join(" · ")} {sel.base ? `· ${sel.base} 기준` : ""} · {sel.type}
            </div>
            <div style={{ fontSize: 13.5, lineHeight: 1.78, color: "var(--ink-dim)" }}>{sel.desc}</div>
            {sel.manifest && (
              <div style={{ marginTop: 14, paddingTop: 13, borderTop: "1px solid var(--line)" }}>
                <div style={{ fontSize: 11, fontWeight: 600, color: "var(--gold)", marginBottom: 8, letterSpacing: 0.5 }}>내 사주에서의 발현 — 자리·글자별</div>
                <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
                  {sel.manifest.split(" / ").map((m, i) => {
                    const [head, ...rest] = m.split(": ");
                    return (
                      <div key={i} style={{ fontSize: 12.5, lineHeight: 1.65, color: "var(--ink-dim)", paddingLeft: 10, borderLeft: "2px solid var(--line-strong)" }}>
                        <b style={{ color: "var(--ink)" }}>{head}</b>{rest.length ? <span> — {rest.join(": ")}</span> : null}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
        </Portal>
      )}
    </div>
  );
}
